import { useQuery } from 'react-query'
import { format } from 'date-fns'

import { useAuthedFetch } from '../../auth/useAuthedFetch'
import withFetchCancel from '../../libs/withFetchCancel'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

/**
 * @param {string} dateStart - Fecha en formato yyyy-mm-dd
 * @param {string} dateEnd - Fecha en formato yyyy-mm-dd
 */
const useInvoices = (
  clientCenterCode,
  dateStart,
  dateEnd,
  pagination = {
    page: 0,
    limit: 10,
  },
) => {
  const authedFetch = useAuthedFetch()

  const queryParams = new URLSearchParams()
  queryParams.append('page_limit', pagination.limit)
  queryParams.append('page_offsets', pagination.page)

  const query = useQuery(
    ['invoices', clientCenterCode, dateStart, dateEnd],
    () =>
      withFetchCancel(signal =>
        authedFetch(
          'POST',
          `${BACKEND_ENDPOINT}/rpc-client-center-docs-for?${queryParams.toString()}`,
          {
            parseJSON: true,
            signal,
            data: {
              client_center_code: clientCenterCode,
              doc_date_ini: dateStart,
              doc_date_end: dateEnd,
            },
          },
        ),
      ),
    {
      select: ({ data }) => {
        const { data: invoices } = data

        return invoices.map(invoice => ({
          id: invoice.doc_final_code,
          date: format(new Date(invoice.doc_date), 'dd/MM/yyyy'),
          uid: invoice.uid,
          clientCode: invoice.client_code,
          amount: invoice.due_value,
          hasPdf: invoice.has_pdf,
          hasXls: invoice.has_xls,
        }))
      },
      enabled: clientCenterCode !== undefined,
    },
  )

  return query
}

export default useInvoices
